import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';

@Pipe({
    name: 'timeAgo',
    pure: false,
    standalone: true
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
  private lastInput: number | null = null;
  private lastOutput: string | null = null;
  private subscription = new Subscription();

  public constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    // we need to regularly re-check that the formatted value should not change
    // A timer is sub-optimal - we could instead calculate exactly when the text would change,
    // but this is a simpler solution and performance will be acceptable because we do not
    // trigger angular change detection unless the formatted value actually changes.
    this.subscription.add(timer(10000, 10000).subscribe(() => {
      const newOutput = this.format(this.lastInput);
      if (newOutput !== this.lastOutput) {
        this.changeDetectorRef.markForCheck();
      }
    }));
  }

  transform(value: number | null): string {
    this.lastInput = value;
    this.lastOutput = this.format(value);
    return this.lastOutput;
  }

  private format(value: number | null): string {
    if (moment().diff(value, 'seconds') < 60) {
      return this.translate.instant('time-ago.just-now');
    } else {
      return moment(value).fromNow();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
